(() => {
  const SELECTOR = '[data-vella-sticky-buy]';
  const QUANTITY_SELECTOR = '.quantity__input[name="quantity"]';
  const OFFER_SELECTOR = '[data-vella-offer-picker] button[data-quantity]';
  const OVERLAY_SELECTOR = 'cart-drawer.active, cart-notification.active, details-modal[open], details-modal details[open], menu-drawer details[open], header-drawer details[open], quick-add-modal[open], product-modal[open], modal-dialog[open], dialog[open]';
  const mobile = window.matchMedia('(max-width: 749px)');
  const stickyStates = new Map();
  let refreshFrame = null;

  const getPrimaryButton = () => document.querySelector('.vella-main-product .product-form__submit');
  function isOverlayOpen() {
    if (document.querySelector(OVERLAY_SELECTOR)) return true;
    return Array.from(document.querySelectorAll('[aria-modal="true"], #shopify-pc__banner')).some((overlay) => {
      const bounds = overlay.getBoundingClientRect();
      return overlay.getClientRects().length && getComputedStyle(overlay).visibility !== 'hidden'
        && bounds.bottom > 0 && bounds.top < window.innerHeight && bounds.right > 0 && bounds.left < window.innerWidth;
    });
  }
  const offerLabel = (quantity) => quantity === 1 ? 'מכשיר אחד' : `${quantity} מכשירים`;

  function setText(element, text) {
    if (element && element.textContent !== text) element.textContent = text;
  }

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== String(value)) element.setAttribute(name, value);
  }

  function syncOfferPicker(product, quantity) {
    const picker = product.querySelector('[data-vella-offer-picker]');
    const priceData = product.querySelector('[data-vella-unit-price]');
    const unitPrice = Number(priceData?.dataset.vellaUnitPrice ?? picker?.dataset.unitPrice);
    const currency = priceData?.dataset.currency || picker?.dataset.currency;
    const formatter = /^[A-Z]{3}$/.test(currency || '')
      ? new Intl.NumberFormat('he-IL', { style: 'currency', currency }) : null;
    product.querySelectorAll(OFFER_SELECTOR).forEach((offer) => {
      const count = Number(offer.dataset.quantity);
      const selected = count === quantity;
      if (offer.classList.contains('is-selected') !== selected) offer.classList.toggle('is-selected', selected);
      setAttribute(offer, 'aria-pressed', selected);
      if (formatter && Number.isSafeInteger(unitPrice) && unitPrice >= 0) {
        setText(offer.querySelector('strong'), formatter.format(offerTotal(unitPrice, count) / 100));
        setText(offer.querySelector('s'), formatter.format(unitPrice * count / 100));
      }
    });
  }

  function offerTotal(unitPrice, quantity) {
    const percent = quantity === 2 ? 80 : quantity === 3 ? 70 : 100;
    // Match Liquid's rounded offer totals, with one rounding step in integer cents.
    return Math.round(unitPrice * quantity * percent / 100);
  }

  function scrollToBuy() {
    const button = getPrimaryButton();
    if (!button) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    button.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    window.setTimeout(() => button.focus({ preventScroll: true }), reduceMotion ? 0 : 350);
  }

  function renderVisibility(root) {
    const state = stickyStates.get(root);
    const primary = state?.primary;
    const rect = primary?.getBoundingClientRect();
    const footer = document.querySelector('footer.footer, footer[role="contentinfo"]');
    const atFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
    const visible = Boolean(mobile.matches && state?.hasPrice && primary?.getClientRects().length
      && rect.bottom <= 0 && !isOverlayOpen() && !atFooter);
    if (root.hidden === visible) root.hidden = !visible;
    if (root.classList.contains('is-visible') !== visible) root.classList.toggle('is-visible', visible);
    setAttribute(root, 'aria-hidden', !visible);
  }

  function updateStickyState(root) {
    const state = stickyStates.get(root);
    const { product, primary, button } = state;
    const input = product?.querySelector(QUANTITY_SELECTOR);
    const priceData = product?.querySelector('[data-vella-unit-price]');
    const quantity = Number(input?.value);
    const rawPrice = priceData?.dataset.vellaUnitPrice ?? root.dataset.unitPrice;
    const unitPrice = Number(rawPrice);
    const currency = priceData?.dataset.currency || root.dataset.currency;
    state.quantity = quantity;
    state.hasPrice = rawPrice !== '' && Number.isSafeInteger(unitPrice) && unitPrice >= 0 && /^[A-Z]{3}$/.test(currency || '');
    if (!product || !primary || !input) {
      state.hasPrice = false;
      button.disabled = true;
      renderVisibility(root);
      return;
    }

    const validQuantity = Number.isSafeInteger(quantity) && quantity > 0 && input.validity.valid;
    syncOfferPicker(product, quantity);
    const cents = offerTotal(unitPrice, quantity);
    const formattedPrice = state.hasPrice && validQuantity
      ? new Intl.NumberFormat('he-IL', { style: 'currency', currency }).format(cents / 100)
      : '';
    setText(root.querySelector('[data-vella-sticky-offer]'), validQuantity ? offerLabel(quantity) : 'בחרי כמות');
    setText(root.querySelector('[data-vella-sticky-price]'), formattedPrice);

    const busy = state.submitting || primary.classList.contains('loading') || primary.getAttribute('aria-busy') === 'true';
    const disabled = busy || primary.disabled || primary.getAttribute('aria-disabled') === 'true' || !validQuantity || !state.hasPrice;
    const primaryLabel = primary.querySelector('span:not(.hidden)')?.textContent.trim() || primary.textContent.trim();
    button.disabled = disabled;
    setAttribute(button, 'aria-disabled', disabled);
    setAttribute(button, 'aria-busy', busy);
    if (button.classList.contains('loading') !== busy) button.classList.toggle('loading', busy);
    setText(button, busy ? 'מוסיף לסל…' : primaryLabel || button.dataset.label);

    const error = product.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message')?.textContent.trim();
    const status = root.querySelector('[data-vella-sticky-status]');
    if (status && status.classList.contains('visually-hidden') === Boolean(error)) status.classList.toggle('visually-hidden', !error);
    setText(status, error || (busy ? `מוסיף ${offerLabel(quantity)} לסל` : validQuantity ? `${offerLabel(quantity)}, סה״כ ${formattedPrice}` : 'בחרי כמות תקינה'));
    renderVisibility(root);
  }

  function submitFromSticky(root) {
    const state = stickyStates.get(root);
    updateStickyState(root);
    const { primary, product, button } = state;
    if (root.hidden || state.submitting || button.disabled || !primary) return;
    const input = product.querySelector(QUANTITY_SELECTOR);
    state.submitting = true;
    updateStickyState(root);
    input.value = String(state.quantity);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    // The native product form owns validation, AJAX, cart, errors and its in-flight lock.
    primary.click();
    queueMicrotask(() => {
      state.submitting = false;
      if (stickyStates.has(root)) updateStickyState(root);
    });
  }

  function observeProduct(root) {
    const state = stickyStates.get(root);
    const product = Array.from(document.querySelectorAll('.vella-main-product'))
      .find((item) => item.dataset.productId === root.dataset.productId);
    state.primary = product?.querySelector('.product-form__submit');
    if (state.product === product) return;
    state.observer?.disconnect();
    state.product = product;
    if (!product) return;
    state.observer = new MutationObserver(() => {
      state.primary = product.querySelector('.product-form__submit');
      updateStickyState(root);
    });
    state.observer.observe(product, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'hidden', 'data-vella-unit-price', 'data-currency', 'value', 'min', 'max', 'step'],
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function initSticky(root) {
    if (stickyStates.has(root)) return;
    const button = root.querySelector('[data-vella-sticky-submit]');
    if (!button) return;
    const onSubmit = () => submitFromSticky(root);
    button.addEventListener('click', onSubmit);
    stickyStates.set(root, { button, onSubmit, submitting: false });
  }

  function destroySticky(root) {
    const state = stickyStates.get(root);
    state.observer?.disconnect();
    state.button.removeEventListener('click', state.onSubmit);
    stickyStates.delete(root);
  }

  function refreshAll() {
    refreshFrame = null;
    stickyStates.forEach((state, root) => { if (!root.isConnected) destroySticky(root); });
    document.querySelectorAll(SELECTOR).forEach((root) => {
      initSticky(root);
      if (!stickyStates.has(root)) return;
      observeProduct(root);
      updateStickyState(root);
    });
  }

  function scheduleRefresh() {
    if (refreshFrame === null) refreshFrame = window.requestAnimationFrame(refreshAll);
  }

  function start() {
    refreshAll();
    document.addEventListener('click', (event) => {
      const offer = event.target.closest(OFFER_SELECTOR);
      const product = offer?.closest('.vella-main-product');
      const input = product?.querySelector(QUANTITY_SELECTOR);
      if (input && !offer.disabled) {
        input.value = offer.dataset.quantity;
        syncOfferPicker(product, Number(input.value));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const scrollTrigger = event.target.closest('[data-vella-scroll-to-buy]');
      if (scrollTrigger && !scrollTrigger.closest(SELECTOR)) scrollToBuy();
    });
    ['input', 'change'].forEach((name) => document.addEventListener(name, (event) => {
      if (event.target.matches(`.vella-main-product ${QUANTITY_SELECTOR}`)) {
        syncOfferPicker(event.target.closest('.vella-main-product'), Number(event.target.value));
        refreshAll();
      }
    }));
    window.addEventListener('scroll', scheduleRefresh, { passive: true });
    window.addEventListener('resize', scheduleRefresh);
    mobile.addEventListener('change', scheduleRefresh);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, scheduleRefresh);
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
      subscribe(PUB_SUB_EVENTS.cartError, scheduleRefresh);
      subscribe(PUB_SUB_EVENTS.quantityUpdate, () => {
        // Dawn resets quantity when refreshing rules. Retain a valid selected offer.
        document.querySelectorAll('.vella-main-product').forEach((product) => {
          const input = product.querySelector(QUANTITY_SELECTOR);
          const selected = product.querySelector('[data-vella-offer-picker] [aria-pressed="true"]');
          if (!input || !selected) return;
          const nativeQuantity = input.value;
          input.value = selected.dataset.quantity;
          if (!input.validity.valid) input.value = nativeQuantity;
        });
        scheduleRefresh();
      });
    }
    const overlayObserver = new MutationObserver((records) => {
      if (records.some((record) => !record.target.closest(SELECTOR))) {
        stickyStates.forEach((state, root) => renderVisibility(root));
      }
    });
    overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'open', 'hidden', 'style', 'aria-modal'], childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('shopify:section:unload', (event) => {
    stickyStates.forEach((state, root) => { if (event.target.contains(root)) destroySticky(root); });
    scheduleRefresh();
  });
})();


/* Prevent Shopify Forms popup from covering the Vella PDP on mobile Safari / in-app browsers. */
(() => {
  const applyVellaMobileFormsGuard = () => {
    if (!document.querySelector('.vella-main-product')) return;

    document.body.classList.add('vella-product-page');

    if (!window.matchMedia('(max-width: 749px)').matches) return;

    document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
      embed.style.setProperty('display', 'none', 'important');
      embed.setAttribute('aria-hidden', 'true');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyVellaMobileFormsGuard, { once: true });
  } else {
    applyVellaMobileFormsGuard();
  }

  const formsObserver = new MutationObserver(applyVellaMobileFormsGuard);
  formsObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.matchMedia('(max-width: 749px)').addEventListener?.('change', applyVellaMobileFormsGuard);
})();
